/* eslint-disable */
import { Helmet } from 'react-helmet-async';
import InfoTooltip from '../components/InfoTooltip';
import { useNavigate, useParams, Link, useLocation, Navigate } from 'react-router-dom';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useState } from 'react';
import { ImSortAmountDesc, ImSortAmountAsc } from 'react-icons/im';
import { MdOutlineEdit } from 'react-icons/md';
import { IoEyeOutline } from 'react-icons/io5';
import { CiTrash } from 'react-icons/ci';
import { FaBuilding, FaMapMarkerAlt, FaArrowRight, FaChevronDown } from 'react-icons/fa';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  CircularProgress,
  TextField,
  Select,
  FormControl,
  Box,
} from '@mui/material';
// import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
// components
import Swal from 'sweetalert2';
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import ContractCard from '../components/SignedContractsComponents/ContractCard';
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock
import appConfig from '../config';
import USERLIST from '../_mock/user';
import {
  deleteCleaner,
  deleteContractor,
  deleteSpecialAccess,
  deleteUser,
  getAllCleaner,
  getAllContractor,
  getAllSpecialAcess,
  getBnbList,
  getUsers,
  deleteUploads,
  getContractProperties,
  updateProperty,
} from '../helper/backend_helper';
import PropertyCard from 'src/components/SignedContractsComponents/PropertyCard';

// ----------------------------------------------------------------------
// const users = [
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
// ];

const TABLE_HEAD = [
  { id: '', label: 'Name', alignRight: true },
  { id: '', label: 'Percentage', alignRight: true },
  { id: '', label: 'Contract Duration', alignRight: true },
  { id: '', label: 'Template Name', alignRight: true },
  { id: '', label: 'Copy Link', alignRight: false },
  { id: '', label: 'Actions', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const getSignedContractMode = (contract) => contract?.signedContractMode || contract?.selectedContractMode || 'standard';

const formatPropertyAddress = (property = {}) =>
  [
    [property.address, property.streetNumber].filter(Boolean).join(' '),
    property.city,
    property.province,
    property.postalCode,
  ]
    .filter(Boolean)
    .join(', ');

const getInstallationRows = (contracts = []) =>
  contracts
    .filter((contract) => getSignedContractMode(contract) === 'allInclusive')
    .flatMap((contract) =>
      (contract.properties || []).map((property) => ({
        contract,
        property,
        address: formatPropertyAddress(property),
      }))
    );

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) =>
        _user.firstName.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        _user.lastName.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function SignedContracts() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [clickedRowData, setClickedRowData] = useState(null);
  const [contracts, setContracts] = useState([]);
  const [filteredContracts, setFilteredContracts] = useState([]);
  const [propertiesByCity, setPropertiesByCity] = useState({});
  const [loading, setLoading] = useState(false);
  const [sortDirection, setSortDirection] = useState('asc');
  const [sortKey, setSortKey] = useState('');
  const [ownerTypeFilter, setOwnerTypeFilter] = useState('');
  const [contractModeFilter, setContractModeFilter] = useState('');
  const [activeTab, setActiveTab] = useState('name');
  const [installationSaving, setInstallationSaving] = useState('');
  const toggleSortDirection = () => {
    setSortDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'));
  };

  const [search, setSearch] = useState('');

  // useEffect(() => {
  //   const filteredData = contracts.filter((item) => {
  //     const fullName = `${item?.name}`.toLowerCase();
  //     return fullName.includes(search.toLowerCase());
  //   });
  //   setFilteredContracts(filteredData);
  // }, [search, contracts]);

  async function fetchData() {
    try {
      setLoading(true);

      const headers = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const data = {
        isSubmitted: true,
      };

      const response = await getAllContractor(data, headers);
      setContracts(response?.data?.data || []);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (activeTab === 'name') {
      // let filtered = contracts.filter((item) => {
      //   const fullName = item?.name?.toLowerCase() || '';
      //   const matchesSearch = fullName.includes(search.toLowerCase());

      //   const matchesOwnerType =
      //     ownerTypeFilter === '' ||
      //     (ownerTypeFilter === 'private' && item.ownerType === 'private') ||
      //     (ownerTypeFilter === 'company' && item.ownerType === 'company');

      //   return matchesSearch && matchesOwnerType;
      // });

      let filtered = contracts.filter((item) => {
        const fullName = item?.name?.toLowerCase() || '';
        const searchLower = search.toLowerCase();

        const matchesSearch =
          fullName.includes(searchLower) ||
          item.properties?.some((property) => {
            const fullAddress = `${property?.address ?? ''} ${property?.streetNumber ?? ''}, ${property?.city ?? ''}, ${
              property?.province ?? ''
            }, ${property?.postalCode ?? ''}`.toLowerCase();

            return fullAddress.includes(searchLower);
          });

        const matchesOwnerType =
          ownerTypeFilter === '' ||
          (ownerTypeFilter === 'private' && item.ownerType === 'private') ||
          (ownerTypeFilter === 'company' && item.ownerType === 'company');
        const matchesContractMode = contractModeFilter === '' || getSignedContractMode(item) === contractModeFilter;

        return matchesSearch && matchesOwnerType && matchesContractMode;
      });

      // Optionally sort
      if (sortKey) {
        filtered = [...filtered].sort((a, b) => {
          const aVal = getSortValue(a, sortKey);
          const bVal = getSortValue(b, sortKey);
          return sortDirection === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
        });
      }

      return setFilteredContracts(filtered);
    }

    if (activeTab === 'installations') {
      return;
    }

    const searchLower = search.toLowerCase();
    let filteredContracts = contracts.filter((item) => {
      const matchesOwnerType =
        ownerTypeFilter === '' ||
        (ownerTypeFilter === 'private' && item.ownerType === 'private') ||
        (ownerTypeFilter === 'company' && item.ownerType === 'company');
      const matchesContractMode = contractModeFilter === '' || getSignedContractMode(item) === contractModeFilter;
      const matchesSearch =
        !search ||
        item.properties?.some((property) => {
          const fullAddress = `${property?.address ?? ''} ${property?.streetNumber ?? ''}, ${property?.city ?? ''}, ${
            property?.province ?? ''
          }, ${property?.postalCode ?? ''}`.toLowerCase();

          return fullAddress.includes(searchLower);
        });

      return matchesOwnerType && matchesContractMode && matchesSearch;
    });

    const grouped = {};

    filteredContracts.forEach((item) => {
      item.properties?.forEach((prop) => {
        const city = prop.city || 'Unknown';
        grouped[city] = grouped[city] || [];
        grouped[city].push(item);
      });
    });

    setPropertiesByCity(grouped);

    // const grouped = {};

    // contracts.forEach((item) => {
    //   item.properties?.forEach((prop) => {
    //     const city = prop.city || 'Unknown';
    //     grouped[city] = grouped[city] || [];
    //     grouped[city].push(item);
    //   });
    // });

    // setPropertiesByCity(grouped);
  }, [search, contracts, sortKey, sortDirection, ownerTypeFilter, contractModeFilter, activeTab]);

  const getSortValue = (item, key) => {
    switch (key) {
      case 'ownerName':
        return `${item?.companyOwner?.lastName || ''}`.toLowerCase();
      case 'propertyName':
        return `${item?.properties?.[0]?.name || ''}`.toLowerCase();
      case 'propertiesCount':
        return `${item?.properties?.length || 0}`;
      case 'dateSigned':
        return new Date(item?.createdAt || '').toISOString();
      default:
        return '';
    }
  };

  const allInclusiveInstallationRows = getInstallationRows(contracts).filter((row) => {
    const searchLower = search.toLowerCase();
    if (!searchLower) return true;

    return [row.property?.name, row.address, row.contract?.name]
      .filter(Boolean)
      .some((value) => String(value).toLowerCase().includes(searchLower));
  });

  const copyInstallationRows = async () => {
    const text = allInclusiveInstallationRows
      .map((row) => {
        const status = row.property?.installationStatus || {};
        return [
          row.property?.name || 'Unnamed property',
          row.address || 'No address saved',
          'Lettore Card: ' + (status.lettoreCard ? 'Done' : 'To do'),
          'Assicurazione: ' + (status.assicurazione ? 'Done' : 'To do'),
        ].join('\n');
      })
      .join('\n\n');

    await navigator.clipboard.writeText(text);
    Swal.fire({ icon: 'success', title: 'Copied installation overview', timer: 1200, showConfirmButton: false });
  };

  const updateInstallationStatus = async (property, field, checked) => {
    const propertyId = property?._id || property?.id;
    if (!propertyId) return;

    const nextStatus = { ...(property.installationStatus || {}), [field]: checked };
    setInstallationSaving(propertyId + '-' + field);

    try {
      // Keep install status directly on the property so every signed all-inclusive contract view reads the same checklist.
      await updateProperty(propertyId, { installationStatus: nextStatus }, { headers: { 'Content-Type': 'application/json' } });
      setContracts((prevContracts) =>
        prevContracts.map((contract) => ({
          ...contract,
          properties: (contract.properties || []).map((item) =>
            String(item._id || item.id) === String(propertyId) ? { ...item, installationStatus: nextStatus } : item
          ),
        }))
      );
    } catch (error) {
      console.error('Error updating installation status:', error);
      Swal.fire({ icon: 'error', title: 'Could not update installation status' });
    } finally {
      setInstallationSaving('');
    }
  };

  const handleDelete = async (row) => {
    console.log(row.signatureFile);
    console.log(row.companyInfo.visuraSocietaria);
    console.log(row.companyOwner.documentCopy);
    console.log(row.companyOwner.fiscalCodeCopy);
    console.log(row.privateOwner.documentCopy);
    console.log(row.privateOwner.fiscalCodeCopy);

    const res = await getContractProperties(row?._id);
    const properties = res?.data?.data || [];
    const propertyImages = properties.flatMap((prop) => [
      ...(prop.visuraCatastale || []),
      ...(prop.rentalContract || []),
      ...(prop.cinCisDocument || []),
      ...(prop.policePortal || []),
    ]);
    console.log(propertyImages);
    const allImages = [
      ...row.signatureFile,
      ...row.companyInfo.visuraSocietaria,
      ...row.companyOwner.documentCopy,
      ...row.companyOwner.fiscalCodeCopy,
      ...row.privateOwner.documentCopy,
      ...row.privateOwner.fiscalCodeCopy,
      ...propertyImages,
    ];
    console.log(allImages);
    try {
      const confirmed = await Swal.fire({
        icon: 'warning',
        title: 'Are you sure you want to delete this Contractor?',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
      });

      if (confirmed.isConfirmed) {
        const headers = {
          headers: {
            'Content-Type': 'application/json',
          },
        };

        await Promise.all(
          allImages.map(async (image) => {
            const data = {
              filename: image,
            };
            await deleteUploads(data, headers); // Delete each image
          })
        );

        const response = await deleteContractor(row._id, headers);
        Swal.fire({
          icon: 'success',
          title: 'Contractor deleted successfully',
        });
        fetchData();
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: 'An error occurred while deleting',
      });
    }
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - contracts.length) : 0;

  const filteredUsers = applySortFilter(contracts, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;
  // const encodedData = encodeURIComponent(JSON.stringify(clickedRow));

  const [isOpen, setIsOpen] = useState(true);
  return (
    <>
      <Helmet>
        <title> Contractor </title>
      </Helmet>

      <Card sx={{ p: 3 }}>
        <Stack mb={3} direction="row" gap={2} alignItems="center" justifyContent="space-start">
          <Typography variant="h4">Contracts{' '}<InfoTooltip width={20} title="Every management contract an owner has signed and submitted, in either Standard or All Inclusive mode, together with its properties, owner details, percentage and duration. Records appear here once the owner completes and submits the contract flow. Search by owner name or property address, sort and filter by owner type or contract mode, switch between the Name, City and Install tabs, and on the Install tab track per-property setup tasks like Lettore Card and Assicurazione." /></Typography>

          <TextField
            onChange={(e) => setSearch(e.target.value)}
            value={search}
            size="small"
            id="outlined-search"
            label="Search field"
            type="search"
          />
          <Box sx={{ minWidth: 260 }}>
            <FormControl fullWidth size="small">
              <Select value={sortKey} onChange={(e) => setSortKey(e.target.value)}>
                <MenuItem value="ownerName">Owner Name</MenuItem>
                <MenuItem value="propertyName">Property Name</MenuItem>
                <MenuItem value="propertiesCount">Properties Count</MenuItem>
                <MenuItem value="dateSigned">Date Signed</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Stack onClick={toggleSortDirection} sx={{ cursor: 'pointer' }} title="Toggle sort direction">
            {sortDirection === 'asc' ? <ImSortAmountAsc size={20} /> : <ImSortAmountDesc size={20} />}
          </Stack>

          <Box sx={{ minWidth: 220 }}>
            <FormControl fullWidth size="small">
              <Select value={contractModeFilter} onChange={(e) => setContractModeFilter(e.target.value)}>
                <MenuItem value="">All Contract Modes</MenuItem>
                <MenuItem value="standard">Standard</MenuItem>
                <MenuItem value="allInclusive">All Inclusive</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ minWidth: 260 }}>
            <FormControl fullWidth size="small">
              <Select value={ownerTypeFilter} onChange={(e) => setOwnerTypeFilter(e.target.value)}>
                <MenuItem value="">All Owners</MenuItem>
                <MenuItem value="private">Private Owners</MenuItem>
                <MenuItem value="company">Companies</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <div className="bg-gray-100 w-80 p-1 rounded-lg flex">
            <div
              onClick={() => setActiveTab('name')}
              className={`flex-1 text-center py-2 cursor-pointer rounded-lg transition 
          ${activeTab === 'name' ? 'bg-white text-black font-semibold' : 'text-gray-500'}`}
            >
              Name
            </div>
            <div
              onClick={() => setActiveTab('city')}
              className={`flex-1 text-center py-2 cursor-pointer rounded-lg transition 
          ${activeTab === 'city' ? 'bg-white text-black font-semibold' : 'text-gray-500'}`}
            >
              City
            </div>
            <div
              onClick={() => setActiveTab('installations')}
              className={`flex-1 text-center py-2 cursor-pointer rounded-lg transition 
          ${activeTab === 'installations' ? 'bg-white text-black font-semibold' : 'text-gray-500'}`}
            >
              Install
            </div>
          </div>
        </Stack>

        <div className="mt-4 space-y-4">
          {loading ? (
            <CircularProgress size={20} />
          ) : activeTab === 'name' ? (
            filteredContracts.map((item, index) => (
              <ContractCard key={index} data={item} sortKey={sortKey} activeTab={activeTab} />
            ))
          ) : activeTab === 'installations' ? (
            <Box sx={{ border: '1px solid #e5e7eb', borderRadius: 1, overflow: 'hidden' }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ p: 2, bgcolor: '#f8fafc' }}>
                <Box>
                  <Typography variant="h6">All Inclusive Device Overview</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {allInclusiveInstallationRows.length} properties requiring install/admin follow-up
                  </Typography>
                </Box>
                <Button variant="outlined" onClick={copyInstallationRows}>
                  Copy for technicians
                </Button>
              </Stack>
              <TableContainer>
                <Table size="small">
                  <TableBody>
                    {allInclusiveInstallationRows.map((row) => {
                      const propertyId = row.property?._id || row.property?.id;
                      const status = row.property?.installationStatus || {};

                      return (
                        <TableRow key={propertyId} hover>
                          <TableCell sx={{ minWidth: 220 }}>
                            <Typography variant="subtitle2">{row.property?.name || 'Unnamed property'}</Typography>
                            <Typography variant="caption" color="text.secondary">
                              {row.contract?.name}
                            </Typography>
                          </TableCell>
                          <TableCell sx={{ minWidth: 360 }}>
                            <Typography variant="body2">{row.address || 'No address saved'}</Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Checkbox
                              checked={Boolean(status.lettoreCard)}
                              disabled={installationSaving === propertyId + '-lettoreCard'}
                              onChange={(event) => updateInstallationStatus(row.property, 'lettoreCard', event.target.checked)}
                            />
                            <Typography variant="caption" display="block">
                              Lettore Card
                            </Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Checkbox
                              checked={Boolean(status.assicurazione)}
                              disabled={installationSaving === propertyId + '-assicurazione'}
                              onChange={(event) =>
                                updateInstallationStatus(row.property, 'assicurazione', event.target.checked)
                              }
                            />
                            <Typography variant="caption" display="block">
                              Assicurazione
                            </Typography>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          ) : (
            Object.entries(propertiesByCity).map(([city, data], index) => (
              <PropertyCard city={city} key={index} data={data} />
            ))
          )}
        </div>
      </Card>
    </>
  );
}
